import { ProfileSkills } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box, Divider } from 'braid-design-system';
import React from 'react';

import { SKILLS } from 'src/components/Router';

import { useShareableProfile } from '../data';

import translations from './.vocab';

export const Skills = () => {
  const { shareableProfile, shareableProfileCardEmpty } = useShareableProfile();
  const { t } = useTranslations(translations);
  const skills = shareableProfile?.skills || [];
  const skillsText = skills?.map((skill) => skill.keyword.text);

  return shareableProfileCardEmpty[SKILLS] ? null : (
    <>
      <Box id={SKILLS} paddingY="xxlarge" data-automation={SKILLS}>
        <Stack space="large">
          <Heading level="3" align="left">
            {t('Skills')}
          </Heading>
          <ProfileSkills skills={skillsText} />
        </Stack>
      </Box>
      <Divider weight="regular" />
    </>
  );
};
